import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { plansPath } from "@hypertune/shared-internal";
import trackAnalyticsEvent from "../../lib/trackAnalyticsEvent";
import BusinessPage from "./BusinessPage";
import Label from "../../components/Label";
import Card from "../../components/Card";
import Button from "../../components/buttons/Button";
import { skipBlockAccountSessionStorageKey } from "../../lib/constants";
import { getPreviousRelativeUrlFromLocation } from "../../lib/query/location";
import { useHypertune } from "../../generated/hypertune.react";

export default function ExtraAccountPage(): React.ReactElement {
  useEffect(() => {
    document.title = "Hypertune";
    trackAnalyticsEvent("extra_account_page_view");
  }, []);

  const location = useLocation();

  const previousRelativeUrl =
    getPreviousRelativeUrlFromLocation(location) ?? "/";

  const navigate = useNavigate();

  const hypertune = useHypertune();

  const blockExtraAccounts = hypertune
    .features()
    .blockExtraAccounts({ fallback: "noBlock" });

  return (
    <BusinessPage>
      <Label type="title1" className="mb-5">
        Team size limit exceeded
      </Label>
      <Card layout="horizontal">
        <div className="flex flex-col gap-[12px]">
          <p className="text-tx-muted">
            It looks like you've exceeded your team size limit. Please upgrade
            your plan. Feel free to reach out over the live chat if you need any
            help or have any questions. If pricing is a concern, we may be able
            to help.
          </p>
          <Button
            text="View plans"
            onClick={async () => {
              await navigate(plansPath);
            }}
            intent="primary"
            weight="outlined"
          />
          {blockExtraAccounts === "softBlock" && (
            <Button
              text="Continue"
              onClick={async () => {
                sessionStorage.setItem(skipBlockAccountSessionStorageKey, "1");
                await navigate(previousRelativeUrl);
              }}
              intent="primary"
              weight="outlined"
            />
          )}
        </div>
      </Card>
    </BusinessPage>
  );
}
